<template>
  <div class="atividade-popup">
    <ul class="atividade-popup-ul">
      <li v-for="e in list" :key="e.id" class="atividade-popup-ul-li" @click="change(e)">
        <div
          :class="[
            'atividade-popup-ul-li--box',
            { active: activeForm.id === e.id },
            { 'un-read': e.unRead },
          ]"
        >
          <template v-if="type === 'atividade'">
            <div class="content-box chxy-row-c-c">
              <van-icon :name="iconType(e.type)" class="atividade-popup-ul-li--box-icon" />
            </div>
          </template>
          <template v-else-if="type === 'site-message'">
            <div class="content-box chxy-row-c-c">
              <img
                v-if="activeForm.id === e.id"
                :src="getImageUrlWithCDN_TEST('/home/emial_icon_on.png', 'local')"
                class="atividade-popup-ul-li--box-img"
              />
              <img
                v-else
                :src="getImageUrlWithCDN_TEST('/home/emial_icon_off.png', 'local')"
                class="atividade-popup-ul-li--box-img"
              />
            </div>
          </template>
          <div class="content-box chxy-row-ac">
            <span class="atividade-popup-ul-li--box-title" v-html="e.title"></span>
          </div>
        </div>
      </li>
    </ul>

    <div class="atividade-popup-main">
      <div class="atividade-popup-main-header">
        {{ $t('home-ad-popup-atividade-model.header') }}
      </div>
      <div v-if="!isFirst" class="page-buttton prev" @click="handleTogglePage('prev')">
        <van-icon name="arrow-left" size="11" />
      </div>
      <div v-if="!isLast" class="page-buttton next" @click="handleTogglePage('next')">
        <van-icon name="arrow" size="11" />
      </div>
      <div class="atividade-popup-main-content">
        <img
          v-if="activeForm.img"
          :src="activeForm.img"
          class="atividade-popup-main-content-img"
          @click="jumpUrl(activeForm.jump_url)"
        />
        <div v-else class="atividade-popup-main-content-html" v-html="activeForm.content"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { siteMessageReadByMessageId } from '@/api/user'

const router = useRouter()

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: 'atividade',
  },
  isHasUnRead: {
    type: Boolean,
    default: false,
  },
})

const activeForm = reactive({
  id: 1,
  title: '',
  content: '',
  img: '',
  type: 1,
  jump_type: 1,
  jump_url: '',
})
const change = (e) => {
  for (const key in activeForm) {
    activeForm[key] = e[key]
  }

  if (props.isHasUnRead) {
    props.list.find((item, i) => {
      if (item.id === e.id) {
        props.list[i].unRead = false
        return true
      }
    })
    setSiteMessageReadByMessageId(e.id)
  }

  emit('change', e)
}
const setSiteMessageReadByMessageId = async (site_message_id) => {
  await siteMessageReadByMessageId({
    site_message_id,
  })
}

const iconType = (type) => {
  switch (type) {
    case 1:
      return 'chat'
    case 2:
      return 'volume'
    default:
      return 'chat'
  }
}

const jumpUrl = (url) => {
  if (url && url !== null) {
    switch (activeForm.jump_type) {
      case 1:
        router.push({ name: url })
        emit('close')
        break
      case 2:
        window.open(url, '_blank')
        break
    }
  }
}

const emit = defineEmits(['change', 'close'])

/**
 * 切换页码
 */
const handleTogglePage = (type) => {
  const currentIndex = props.list.findIndex((item) => item.id === activeForm.id)
  let targetIndex

  if (type === 'prev') {
    targetIndex = currentIndex - 1
    if (targetIndex < 0) targetIndex = 0
  } else if (type === 'next') {
    targetIndex = currentIndex + 1
    if (targetIndex >= props.list.length) targetIndex = props.list.length - 1
  } else {
    return
  }
  const targetItem = props.list[targetIndex]
  if (targetItem && targetItem.id !== activeForm.id) {
    change(targetItem)
  }
}
// 判断当前是否为第一项
const isFirst = computed(() => {
  if (!props.list.length) return true
  return props.list[0].id == activeForm.id
})

// 判断当前是否为最后一项
const isLast = computed(() => {
  if (!props.list.length) return true
  return props.list[props.list.length - 1].id == activeForm.id
})
defineExpose({
  change,
  jumpUrl,
})
</script>

<style scoped lang="scss">
$__atividade-popup-height: 220px;
.atividade-popup {
  display: grid;
  grid-template-columns: 80px auto;
  width: 90vw;
  height: $__atividade-popup-height;
  background-color: var(--atividade-popup-bg);
  border-radius: 15px;
  overflow: hidden;

  .atividade-popup-ul {
    background-color: var(--atividade-popup-ul-bg);
    height: $__atividade-popup-height;
    overflow-y: scroll;

    .atividade-popup-ul-li {
      .atividade-popup-ul-li--box {
        position: relative;
        display: grid;
        grid-template-columns: 16px calc(100% - 20px);
        padding: 0 8px;
        height: 40px;
        background-color: var(--atividade-popup-ul-item-bg);
        font-size: 11px;
        line-height: 1.2;

        &.active {
          background-color: var(--atividade-popup-ul-item-active-bg);

          .atividade-popup-ul-li--box-icon {
            color: var(--atividade-popup-ul-item-active-icon);
          }
          .atividade-popup-ul-li--box-title {
            color: var(--atividade-popup-ul-item-active-text);
          }
        }

        .atividade-popup-ul-li--box-icon {
          font-size: 12px;
          color: var(--atividade-popup-ul-item-icon);
          margin-right: 4px;
        }
        .atividade-popup-ul-li--box-img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
        .atividade-popup-ul-li--box-title {
          display: -webkit-box; /* 使用弹性盒子布局 */
          -webkit-box-orient: vertical; /* 垂直排列 */
          -webkit-line-clamp: 2; /* 限制显示行数 */
          overflow: hidden; /* 隐藏溢出内容 */
          text-align: left;
          color: var(--atividade-popup-ul-item-text);
        }

        &.un-read {
          &::after {
            position: absolute;
            top: 5px;
            right: 5px;
            content: '';
            width: 8px;
            height: 8px;
            background-color: var(--special-red-10);
            border-radius: 50%;
          }
        }
      }
    }
  }

  .atividade-popup-main {
    position: relative;
    height: $__atividade-popup-height;
    overflow-y: auto;

    .atividade-popup-main-header {
      padding: 8px 10px;
      font-size: 13px;
      font-weight: 600;
      line-height: 1.3;
      color: #e03e2d;
      text-align: center;
      border-bottom: 0.5px solid var(--atividade-popup-content-label, #e5e5e5);
    }

    .page-buttton {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      color: #fff;
      font-size: 9px;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      cursor: pointer;
      &.prev {
        left: 5px;
      }
      &.next {
        right: 5px;
      }
    }
    .atividade-popup-main-content {
      display: inline;
      height: calc(#{$__atividade-popup-height} - 30px);
      color: var(--atividade-popup-content-value);

      .atividade-popup-main-content-img {
        width: 100%;
        height: 100%;
      }
      .atividade-popup-main-content-html {
        padding: 10px;
      }
    }
  }
}
</style>
